import { render, staticRenderFns } from "./UpdatesList.vue?vue&type=template&id=41c74c15&scoped=true&"
import script from "./UpdatesList.vue?vue&type=script&lang=js&"
export * from "./UpdatesList.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesList.vue?vue&type=style&index=0&id=41c74c15&lang=scss&scoped=true&"
import style1 from "./UpdatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c74c15",
  null
  
)

export default component.exports